var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"cards-main__link blue-btn",attrs:{"href":_vm.$root.baseUrl + '/real-estate'}},[_vm._v("\n    "+_vm._s(_vm._f("trans")(_vm.finalText))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }